module.exports = function() {
  return new Worker(__webpack_public_path__ + "a4410eb5b46c4c4852d9.worker.js");
};